module.exports = __webpack_public_path__ + "static/media/nachos.f18be9a6.jpg";